import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import AddAccount from "./create";
import ListAccount from "./list";
class DevelopAccount extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isAddAccount: false,
    };
  }
  componentDidMount = () => {
  };
  addNewAccount = () => {
    this.setState({ isAddAccount: !this.state.isAddAccount });
  }
  render() {
    const { t } = this.props;
    return (
      <div style={{ margin: -24 }}>
        {this.state.isAddAccount ? (
          <AddAccount
            addNewAccount={this.addNewAccount}
          />
        ) : (
          <ListAccount
            onRef={(id) => (this.ListBooking = id)}
            addNewAccount={this.addNewAccount}
            listBookings={this.props.listBookings}
          />
        )}
      </div>
    );
  }
}

DevelopAccount.propTypes = {
};
const mapState = (state) => ({
});

const mapDispatch = (dispatch) => ({
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(DevelopAccount));
